module.exports = __webpack_public_path__ + "app/kiss-seller/inactive-form-35XmfFuQ.html";